export default __webpack_public_path__ + "static/hero-layer-3-f084db5a096bbfb530364cc5f2acf660.svg";